import { APP_ROUTES } from '../../../app-routes';

export const SETTINGS_ROUTES = {
  Organisation: 'organisation',
  Loyalty: 'loyalty',
  Notifications: 'notifications',
  TaxRules: 'tax-rules',
  PaymentMethods: 'payment-methods',
  Prescribers: 'prescribers',
  Integrations: 'integrations',
  About: 'about'
};

const BASE = APP_ROUTES.Settings;
export const SettingsPaths = {
  Base: `/${BASE}`,
  Organisation: `/${BASE}/${SETTINGS_ROUTES.Organisation}`,
  Loyalty: `/${BASE}/${SETTINGS_ROUTES.Loyalty}`,
  Notifications: `/${BASE}/${SETTINGS_ROUTES.Notifications}`,
  TaxRules: `/${BASE}/${SETTINGS_ROUTES.TaxRules}`,
  PaymentMethods: `/${BASE}/${SETTINGS_ROUTES.PaymentMethods}`,
  Prescribers: `/${BASE}/${SETTINGS_ROUTES.Prescribers}`,
  Integrations: `/${BASE}/${SETTINGS_ROUTES.Integrations}`,
  About: `/${BASE}/${SETTINGS_ROUTES.About}`
};

export const PayoutsPaths = {
  Base: `/${APP_ROUTES.Payouts}`
};

export const TaxRulesPaths = {
  Base: `/${APP_ROUTES.TaxRules}`
};
